<template>
  <q-list
    class="column q-mx-auto full-width"
    style="width: 100%; max-width: 800px"
  >
    <q-item
      v-for="salesItem in categoryItems"
      :key="salesItem.id"
      class="q-pa-none column"
    >
      <activity-sales-item-card
        :activity-booking="activityBooking"
        :item="salesItem"
      />
    </q-item>
  </q-list>
</template>

<script>
import ActivityBooking from 'src/models/activity/ActivityBooking'
import ActivitySalesItemCard from 'src/modules/checkout/components/ActivitySalesItemCard.vue'
import { useAvailableActivityAddOns } from 'src/modules/checkout/composables/activity-availability/AvailableActivityAddOns'
export default {
  name: 'ActivitySalesCategoryPage',
  components: {
    ActivitySalesItemCard
  },
  props: {
    activityBooking: {
      type: ActivityBooking,
      required: true
    }
  },
  setup () {
    const { computeAvailableActivityAddOns } = useAvailableActivityAddOns()

    return {
      computeAvailableActivityAddOns
    }
  },
  computed: {
    categoryItems () {
      const activityAddOns = _(this.activityBooking.activity.activityCategories.data).map('category.items.data').flatten().value()
      return this.computeAvailableActivityAddOns(activityAddOns)
    }
  }
}
</script>
